import React, { useState,useEffect } from "react";
import { API_URL_LOCALE_BASE } from "../../configuration/config";
import axios from "axios";
import Swal from "sweetalert2";
import Loading from "../../Components/shared/Loading/Loading";
import Select from 'react-select';
import { getDataGrafico } from "../../services/service";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export interface ResUser {
  cantidadDecimal: number;
  disableFilter: boolean;
  formatoGraph: string;
  id: number;
  mostrarDatos: boolean;
  mostrarLinea: boolean;
  mostrarPie: boolean;
  nombreGrafico: string;
  path: string;
  pieTexto: string;
  subtitulo: string;
  tituloGraph: string;
  tipoGraph: number;
  arrayValues: any;
  titleY: string;
  mostrarNegativos: boolean;
  mostrarlegend: boolean;
  isRevertGraphY:boolean;
  isThousandFormat:boolean;
  isMiniGraph:boolean;
  isYAxisActive:boolean;
  yAxisMax:number;

}
const customStyles = {
  option: (provided: any, state: any) => ({
      ...provided,
      padding: 4,
      fontSize: 11,
  }),
  multiValue: (base: any, state: any) => {
      return { ...base, fontSize: 14 };
  },
  singleValue: (provided: any, state: any) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
      return { ...provided, opacity, transition };
  }
};

const CrearGraficoDinamic = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState("");
  const [tagValue, settagValue] = useState("");
  const [filePicked, setFilePicked] = useState(false);
  const [selectOptions, setSelectOptions] = useState([]);
  // const [valuesSelected, setValuesSelected] = useState([]);
  const [currentDatasetItem, setCurrentDatasetItem] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [selectGraph, setSelectGraph] = useState({label:'',value:''});
  const [labels, setLabels] = useState([]);



  const settingData: any = (data: any,title:any) => {
    if (data) {
        let response: any = {
            name: '',
            data: []
        };
        let ikey: number = 0
        data.map((item :any) => {
            for (const key in item) {
                for (const key2 in item[key]) {
                    let auxObj :any = item[key][key2];
                    if(key2 === title){
                        response.name = auxObj;
                    } else {
                        if(auxObj !== "-"){
                            let num = parseFloat(auxObj);
     
                            response.data.push([ikey, num]);
                        }
                        ikey++;
                    }
                }
            }
        });
        return response;
    } else {
        return 'No Data'
    }
}
  const arrayDataset = async (data: any = [],title='') => {
    let arrayItem: any = [], auxArrayToUse: any = [];
    auxArrayToUse = data.length === 0 ? apiData : data;
    await auxArrayToUse.reduce(async (waitExcel: any, dataItem: any) => {
        await waitExcel;
        const dataFormat = await settingData(dataItem,title);
        arrayItem.push(dataFormat);
    }, Promise.resolve());
    return arrayItem
}
  const onChangeSelect = async (itemsSelected: any) => {
    const values: string[] = itemsSelected.map((item: any) => item.value);
  
const defaultData = {
    label: '',
    data: [],
    borderColor: '',
    fill: false,
    tension: 0.4,
};

    setFormularioEditGraph((prevForm) => ({
      ...prevForm,
      ['listadoValores']:itemsSelected
    }));
    if (values.length === 0) {
        setCurrentDatasetItem([]);
        return defaultData;
    }
    // const updatedItemsDataset: any = [];
    // const dataSet = await arrayDataset();
    // let datasetItem: any = [];
    // values.forEach((val: any) => {
    //     datasetItem = dataSet.find((item: any) => item.name === val);
    //     if (datasetItem) {
    //         updatedItemsDataset.push(datasetItem);
    //     }
    // });
    // console.log('valores',updatedItemsDataset)
    // setCurrentDatasetItem(updatedItemsDataset);
}
  const [formulario, setFormulario] = useState({
    idgraph: "-1",
    ruta: "",
    tipoGrafico: 1,
    nombreGrafico: "",
    tituloGrafico: "",
    subtitulo: "",
    textoPiePagina: "",
    formato: "%",
    desactivarFiltro: 1,
    cantidadDecimales: 0,
    mostrarPiePagina: 1,
    mostrarLineaTop: 1,
    mostrarValores: 1,
    titleY: '',
    isShowNegativeValue: 0,
    isShowLegendGraph: 1,
    isReventGraph:0,
    isThousandFormat:0,
    isMiniGraph:0,
    isYAxisActive:0,
    yAxisMax:100

  });

  const [formularioEditGraph, setFormularioEditGraph] = useState({
    idgraph: -1,
    ruta: "",
    tipoGrafico: 1,
    nombreGrafico: "",
    tituloGrafico: "",
    subtitulo: "",
    textoPiePagina: "",
    formato: "",
    cantidadDecimales: 2,
    desactivarFiltro: true,
    mostrarPiePagina: true,
    mostrarLineaTop: true,
    mostrarValores: true,
    listadoValores: [],
    titleY: '',
    isShowNegativeValue: false,
    isShowLegendGraph: false,
    isReventGraph:false,
    isThousandFormat:false,
    isMiniGraph:false,
    isYAxisActive:true,
    yAxisMax:0

  });

  const HandleChange = (e: any) => {
    setFile(e.target.files[0]);
    setFilePicked(true);
  };

  const HandleSubmit = (event: any) => {
    setIsLoading(true);
    event.preventDefault();
    const formData: any = new FormData();
    formData.append("file_excel", file);
    formData.append("tipoGrafico", formulario.tipoGrafico);
    formData.append("nombreGrafico", formulario.nombreGrafico);
    formData.append("ruta", formulario.ruta);
    formData.append("tituloGrafico", formulario.tituloGrafico);
    formData.append("subtitulo", formulario.subtitulo);
    formData.append("textoPiePagina", formulario.textoPiePagina);
    formData.append("formato", formulario.formato);
    formData.append("desactivarFiltro", formulario.desactivarFiltro);
    formData.append("cantidadDecimales", formulario.cantidadDecimales);
    formData.append("mostrarPiePagina", formulario.mostrarPiePagina);
    formData.append("mostrarLineaTop", formulario.mostrarLineaTop);
    formData.append("mostrarValores", formulario.mostrarValores);
    formData.append("titleY", formulario.titleY);
    formData.append("mostrarValoresNegativos", formulario.isShowNegativeValue);
    formData.append("mostrarLeyenda", formulario.isShowLegendGraph);
    formData.append("voltearGrafico", formulario.isReventGraph);
    formData.append("isThousandFormat", formulario.isThousandFormat);
    formData.append("isYAxisActive", formulario.isYAxisActive);
    formData.append("yAxisMax", formulario.yAxisMax);

    const typeData = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NTg5NTY3NzAsImlhdCI6MTY1ODk1NjcxMCwiaXNzIjoia2VuIiwiZGF0YSI6eyJpZCI6MSwibG9naW5fdGltZSI6MTY1ODk1NjcxMH19.45uOgB5kJN6b171vgpOxKILot0_QM9LdYVI119SNdRc",
      },
    };

    axios
      .post(API_URL_LOCALE_BASE + "crear-graph-dinamic", formData, typeData)
      .then(async (response: any) => {
        let { data } = response;
        if (parseInt(data.status) === 200) {
          Toast.fire({
            icon: "success",
            title: "Archivo Excel Ingresado con Exito!",
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "Error: Status " + data.status,
          });
        }
        setIsLoading(false);
      });
  };

 const handleSubmitEdit = (event: any) => {
event.preventDefault();
    console.log(formularioEditGraph);
    
    const formData: any = new FormData();
    formData.append("idgraph", formularioEditGraph.idgraph);
    formData.append("tipoGrafico", formularioEditGraph.tipoGrafico);
    formData.append("ruta", formularioEditGraph.ruta);
    formData.append("tituloGrafico", formularioEditGraph.tituloGrafico);
    formData.append("subtitulo", formularioEditGraph.subtitulo);
    formData.append("textoPiePagina", formularioEditGraph.textoPiePagina);
    formData.append("formato", formularioEditGraph.formato);
    formData.append("desactivarFiltro", formularioEditGraph.desactivarFiltro);
    formData.append("cantidadDecimales", formularioEditGraph.cantidadDecimales);
    formData.append("mostrarPiePagina", formularioEditGraph.mostrarPiePagina);
    formData.append("mostrarLineaTop", formularioEditGraph.mostrarLineaTop);
    formData.append("mostrarValores", formularioEditGraph.mostrarValores);
    formData.append("arrayValores",  JSON.stringify(formularioEditGraph.listadoValores));
    formData.append("titleY", formularioEditGraph.titleY);
    formData.append("mostrarValoresNegativos", formularioEditGraph.isShowNegativeValue);
    formData.append("mostrarLeyenda", formularioEditGraph.isShowLegendGraph);
    formData.append("voltearGrafico", formularioEditGraph.isReventGraph);
    formData.append("isThousandFormat", formularioEditGraph.isThousandFormat);
    formData.append("isMiniGraph", formularioEditGraph.isMiniGraph);
    formData.append("isYAxisActive", formularioEditGraph.isYAxisActive);
    formData.append("yAxisMax", formularioEditGraph.yAxisMax);
    const typeData = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NTg5NTY3NzAsImlhdCI6MTY1ODk1NjcxMCwiaXNzIjoia2VuIiwiZGF0YSI6eyJpZCI6MSwibG9naW5fdGltZSI6MTY1ODk1NjcxMH19.45uOgB5kJN6b171vgpOxKILot0_QM9LdYVI119SNdRc",
      },
    };

    axios
      .post(API_URL_LOCALE_BASE + "editarGraph", formData, typeData)
      .then(async (response: any) => {
        let { data } = response;
        if (parseInt(data.status) === 200) {
          Toast.fire({
            icon: "success",
            title: "Grafico Actualizado correctamente",
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "Error: Status " + data.status,
          });
        }
        setIsLoading(false);
      });

  }
  const handleChange = (e: any) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setFormulario((prevForm) => ({
      ...prevForm,
      [name]: newValue,
    }));
  };
  const handleChangeFormularioEdit = (e: any) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    if (['desactivarFiltro',
      'mostrarPiePagina',
      'mostrarLineaTop',
      'mostrarValores',
      'isShowNegativeValue',
      'isShowLegendGraph',
      'isReventGraph',
      'isThousandFormat',
      'isMiniGraph',
      'isYAxisActive'
    ].includes(name)) {
      setFormularioEditGraph((prevForm) => ({
        ...prevForm,
        [name]: newValue == 1 ? true : false,
      }));
      return;
    }
    setFormularioEditGraph((prevForm) => ({
      ...prevForm,
      [name]: newValue,
    }));
  };
  const HandleChangeEdit = (e:any) => {
    console.log(e.value);
    const graph:ResUser = props.options.find((item: any) => item.id === parseInt(e.value));
    setSelectGraph(e)
    console.log('====================================');
    console.log(graph);
    console.log('====================================');
    llamarInputs(graph);

    
    setFormularioEditGraph({
      idgraph: graph.id,
      ruta: graph.path,
      tipoGrafico: graph.tipoGraph,
      nombreGrafico: graph.nombreGrafico,
      tituloGrafico: graph.tituloGraph,
      subtitulo: graph.subtitulo,
      textoPiePagina: graph.pieTexto,
      formato: graph.formatoGraph,
      desactivarFiltro: graph.disableFilter,
      cantidadDecimales: graph.cantidadDecimal,
      mostrarPiePagina: graph.mostrarPie,
      mostrarLineaTop: graph.mostrarLinea,
      mostrarValores: graph.mostrarDatos,
      listadoValores: graph.arrayValues,
      titleY: graph.titleY,
      isShowNegativeValue: graph.mostrarNegativos,
      isShowLegendGraph: graph.mostrarlegend,
      isReventGraph: graph.isRevertGraphY,
      isThousandFormat: graph.isThousandFormat,
      isMiniGraph: graph.isMiniGraph,
      isYAxisActive: graph.isYAxisActive,
      yAxisMax: graph.yAxisMax
    })
  }

 



  const getLabels: any = (data: any,title:any) => {
    let arrayAux: any = [], arrayAux2: any = [];
    data.map((items:any) => {
        items.map((item:any, index:number) => {
            for (const key in item) {
                let nomKey :string =  Object.keys(item[key])[0];
                if( title !== nomKey){
                    arrayAux.push(nomKey)
                }
            }
        });
    });
    let labels:any = arrayAux.filter((valor:any, indice:number) => {
        return arrayAux.indexOf(valor) === indice;
    });
    setLabels(labels);
}
  


const llamarInputs = async (obj:any) => {

  getDataGrafico(obj.idGraficoData).then(async (response: any) => {
    let { data, status } = response;
    if (parseInt(status) == 200) {
        let apiData: any = data.data.dataGrafico.Hoja1;

        setApiData(apiData);
        await getLabels(apiData,obj.labelGrafico);
        let aux: any = [];
        await arrayDataset(apiData,obj.labelGrafico).then(async (funcResponse: any) => {
          obj.arrayValues.map((item: any) => {
             const auxItem: any = funcResponse.find((element: any) => item.label == element.name);
             aux.push({label: item.label, value: auxItem.name});

         })
     });
     setFormularioEditGraph((prevForm) => ({
      ...prevForm,
      ['listadoValores']:aux
    }));


        setSelectOptions(await getOptionsOfSelect(apiData, obj.labelGrafico));
    } else {
        console.error('Error: ' + status);
    }
});
}

  const getOptionsOfSelect = (data :any,title:any) => {
    return data.map((item :any) => {
        for (const key in item) {
            for (const key2 in item[key]) {
                let aux :any = item[key][key2][title];
                if(aux !== undefined){
                    return (
                        {
                            label: aux,
                            value: aux
                        }
                    )
                }
            }
        }
    })
}
  
  return (
    <>
      {isLoading ? <Loading loading={isLoading} /> : null}

      {/* Creacion Grafico */}
      <div className="card m-2 mt-4">
  <div className="card-header">
    <h1>Crear Gráfico</h1>
  </div>
  <div className="card-body">
    <form>
      <div className="mb-3">
        <label htmlFor="nombreGrafico" className="form-label">
          Nombre del Gráfico
        </label>
        <input
          type="text"
          id="nombreGrafico"
          name="nombreGrafico"
          value={formulario.nombreGrafico}
          onChange={handleChange}
          className="form-control"
        />
      </div>

      <div className="mb-3">
        <label htmlFor="excel" className="form-label">
          Seleccione el archivo Excel que desea cargar
        </label>
        <input
          type="file"
          id="excel"
          name="excel"
          onChange={HandleChange}
          className="form-control"
        />
      </div>

      <div className="mb-3">
        <label htmlFor="tipoGrafico" className="form-label">Tipo de gráfico</label>
        <select
          id="tipoGrafico"
          name="tipoGrafico"
          value={formulario.tipoGrafico}
          onChange={handleChange}
          className="form-select"
        >
          <option value={1}>Lineal</option>
          <option value={2}>Torta</option>
          <option value={3}>Barra</option>
        </select>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="ruta" className="form-label">Ruta</label>
          <input
            type="text"
            id="ruta"
            name="ruta"
            value={formulario.ruta}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="tituloGrafico" className="form-label">Título del Gráfico</label>
          <input
            type="text"
            id="tituloGrafico"
            name="tituloGrafico"
            value={formulario.tituloGrafico}
            onChange={handleChange}
            className="form-control"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="subtitulo" className="form-label">Subtítulo</label>
          <input
            type="text"
            id="subtitulo"
            name="subtitulo"
            value={formulario.subtitulo}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="textoPiePagina" className="form-label">Texto Pie de Página</label>
          <input
            type="text"
            id="textoPiePagina"
            name="textoPiePagina"
            value={formulario.textoPiePagina}
            onChange={handleChange}
            className="form-control"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="titleY" className="form-label">Título Y</label>
          <input
            type="text"
            id="titleY"
            name="titleY"
            value={formularioEditGraph.titleY}
            onChange={handleChangeFormularioEdit}
            className="form-control"
          />
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="formato" className="form-label">Formato</label>
          <select
            id="formato"
            name="formato"
            value={formulario.formato}
            onChange={handleChange}
            className="form-select"
          >
            <option value="">Numérico</option>
            <option value="%">Porcentaje</option>
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="desactivarFiltro" className="form-label">Desactivar Filtro</label>
          <select
            id="desactivarFiltro"
            name="desactivarFiltro"
            value={formulario.desactivarFiltro}
            onChange={handleChange}
            className="form-select"
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="cantidadDecimales" className="form-label">Cantidad de Decimales</label>
          <input
            type="number"
            id="cantidadDecimales"
            name="cantidadDecimales"
            value={formulario.cantidadDecimales}
            onChange={handleChange}
            className="form-control"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="mostrarPiePagina" className="form-label">Mostrar Pie de Arriba</label>
          <select
            id="mostrarPiePagina"
            name="mostrarPiePagina"
            value={formulario.mostrarPiePagina}
            onChange={handleChange}
            className="form-select"
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="mostrarLineaTop" className="form-label">Mostrar Línea Top</label>
          <select
            id="mostrarLineaTop"
            name="mostrarLineaTop"
            value={formulario.mostrarLineaTop}
            onChange={handleChange}
            className="form-select"
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="mostrarValores" className="form-label">Mostrar Valores</label>
          <select
            id="mostrarValores"
            name="mostrarValores"
            value={formulario.mostrarValores}
            onChange={handleChange}
            className="form-select"
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="isShowNegativeValue" className="form-label">Mostrar Valores Negativos</label>
          <select
            id="isShowNegativeValue"
            name="isShowNegativeValue"
            value={formulario.isShowNegativeValue}
            onChange={handleChange}
            className="form-select"
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4 mb-3">
          <label htmlFor="isShowLegendGraph" className="form-label">Mostrar Leyenda</label>
          <select
            id="isShowLegendGraph"
            name="isShowLegendGraph"
            value={formulario.isShowLegendGraph}
            onChange={handleChange}
            className="form-select"
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="isReventGraph" className="form-label">Voltear Gráfico</label>
          <select
            id="isReventGraph"
            name="isReventGraph"
            value={formulario.isReventGraph}
            onChange={handleChange}
            className="form-select"
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="isThousandFormat" className="form-label">Formato Mil</label>
          <select
            id="isThousandFormat"
            name="isThousandFormat"
            value={formulario.isThousandFormat}
            onChange={handleChange}
            className="form-select"
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="isMiniGraph" className="form-label">Is Mini</label>
          <select
            id="isMiniGraph"
            name="isMiniGraph"
            value={formulario.isMiniGraph}
            onChange={handleChange}
            className="form-select"
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="isYAxisActive" className="form-label">Is Y Axis Active</label>
          <select
            id="isYAxisActive"
            name="isYAxisActive"
            value={formulario.isYAxisActive}
            onChange={handleChange}
            className="form-select"
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>

      </div>

      <div className="col-md-4 mb-3">
        <label htmlFor="yAxisMax" className="form-label">Y Axis Max</label>
        <input
          type="number"
          id="yAxisMax"
          name="yAxisMax"
          value={formulario.yAxisMax}
          onChange={handleChange}
          className="form-control"
        />
      </div>
     

        

      </div>

      <div className="d-grid gap-2 d-md-flex justify-content-md-end">
        <button
          type="submit"
          className="btn btn-primary"
          onClick={HandleSubmit}
        >
          Crear Gráfico
        </button>
      </div>
    </form>
  </div>
</div>

      {/* ! Actualizar  Grafico */}
      <div className="card m-2 mt-4">
  <div className="card-header d-flex justify-content-between">
    <h1>Actualizar Gráfico Dinámico</h1>

    <button className="btn btn-info">
      <a href="https://fe-asup-graph-bx2d675z4a-ue.a.run.app/carga" className="btn btn-info">
       Ir a actualizar Excel 
      </a>
    </button>
  </div>
  <div className="card-body">
    <form>
      {/* Tipo de Gráfico */}
      <div className="mb-3">
        <label htmlFor="tipoGrafico" className="form-label">Grafico</label>
        {/* <Select
          id="tipoGrafico"
          name="tipoGrafico"
          className="form-select"
          defaultValue="0"
          onChange={(e: any) =>
            HandleChangeEdit(e)
          }
        >
          <option value="0">Seleccione un tipo de gráfico</option>
          {props.options.map((item: any) => (
            <option value={item.id} key={item.id}>
              {item.nombreGrafico}-{item.idGraficoData}
            </option>
          ))}
        </Select> */}

<Select
                 className="react-select-container"
                 classNamePrefix="react-select"
                    placeholder="Seleccionar..."
                    styles={customStyles}
                    closeMenuOnSelect={true}
                    options={props.options.map((item: any) => {
                      return { 
                          value: item.id, 
                          // label: item.nombreGrafico + ' ' + item.idGraficoData + ' ' + item.path,
                          label: item.nombreGrafico + ' ' + item.idGraficoData ,

                          fullLabel: item.nombreGrafico + ' ' + item.idGraficoData + ' ' + item.path // Aquí concatenamos todo
                        };
                      
                  })}     
                                 onChange={HandleChangeEdit}
                                 filterOption={(candidate:any, input) => {
                                  // Buscamos una coincidencia con el fullLabel que incluye el nombre, ID y URL
                                  // console.log('====================================');
                                  // console.log(candidate.data.fullLabel.toLowerCase().includes(input.toLowerCase()), candidate.data, input);
                                  // console.log('====================================');
                                  return candidate.data.fullLabel.toLowerCase().includes(input.toLowerCase());
                              }}
                    value={selectGraph}
                />
      </div>

   

      {/* Ruta y Título Gráfico */}

      <div className="mb-3">
        <label htmlFor="tipoGrafico" className="form-label">Tipo de gráfico</label>
        <select
          id="tipoGrafico"
          name="tipoGrafico"
          value={formularioEditGraph.tipoGrafico}
          onChange={handleChangeFormularioEdit}
          className="form-select"
        >
          <option value={1}>Lineal</option>
          <option value={2}>Torta</option>
          <option value={3}>Barra</option>
        </select>
      </div>

      <div className="row">
        
        <div className="col-md-6 mb-3">
          
          <label htmlFor="ruta" className="form-label">Ruta</label>
          <input
            type="text"
            className="form-control"
            id="ruta"
            name="ruta"
            value={formularioEditGraph.ruta}
            onChange={handleChangeFormularioEdit}
          />
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="tituloGrafico" className="form-label">Título Gráfico</label>
          <input
            type="text"
            className="form-control"
            id="tituloGrafico"
            name="tituloGrafico"
            value={formularioEditGraph.tituloGrafico}
            onChange={handleChangeFormularioEdit}
          />
        </div>
      </div>

      {/* Subtítulo y Texto Pie de Página */}
      <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="subtitulo" className="form-label">Subtítulo</label>
          <input
            type="text"
            className="form-control"
            id="subtitulo"
            name="subtitulo"
            value={formularioEditGraph.subtitulo}
            onChange={handleChangeFormularioEdit}
          />
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="textoPiePagina" className="form-label">Texto Pie de Página</label>
          <input
            type="text"
            className="form-control"
            id="textoPiePagina"
            name="textoPiePagina"
            value={formularioEditGraph.textoPiePagina}
            onChange={handleChangeFormularioEdit}
          />
        </div>
      </div>

      {/* Título Y y Formato */}
      <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="titleY" className="form-label">Título Y</label>
          <input
            type="text"
            className="form-control"
            id="titleY"
            name="titleY"
            value={formularioEditGraph.titleY}
            onChange={handleChangeFormularioEdit}
          />
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="formato" className="form-label">Formato</label>
          <select
            id="formato"
            name="formato"
            className="form-select"
            value={formularioEditGraph.formato}
            onChange={handleChangeFormularioEdit}
          >
            <option value="">Numérico</option>
            <option value="%">Porcentaje</option>
          </select>
        </div>
      </div>

      {/* Desactivar Filtro y Cantidad de Decimales */}
      <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="desactivarFiltro" className="form-label">Desactivar Filtro</label>
          <select
            id="desactivarFiltro"
            name="desactivarFiltro"
            className="form-select"
            value={formularioEditGraph.desactivarFiltro ? 1 : 0}
            onChange={handleChangeFormularioEdit}
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="cantidadDecimales" className="form-label">Cantidad Decimales</label>
          <input
            type="number"
            className="form-control"
            id="cantidadDecimales"
            name="cantidadDecimales"
            value={formularioEditGraph.cantidadDecimales}
            onChange={handleChangeFormularioEdit}
          />
        </div>
      </div>

      {/* Mostrar Pie, Línea Top y Valores */}
      <div className="row">
        <div className="col-md-4 mb-3">
          <label htmlFor="mostrarPiePagina" className="form-label">Mostrar Pie de Arriba</label>
          <select
            id="mostrarPiePagina"
            name="mostrarPiePagina"
            className="form-select"
            value={formularioEditGraph.mostrarPiePagina ? 1 : 0}
            onChange={handleChangeFormularioEdit}
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="mostrarLineaTop" className="form-label">Mostrar Línea Top</label>
          <select
            id="mostrarLineaTop"
            name="mostrarLineaTop"
            className="form-select"
            value={formularioEditGraph.mostrarLineaTop ? 1 : 0}
            onChange={handleChangeFormularioEdit}
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="mostrarValores" className="form-label">Mostrar Valores</label>
          <select
            id="mostrarValores"
            name="mostrarValores"
            className="form-select"
            value={formularioEditGraph.mostrarValores ? 1 : 0}
            onChange={handleChangeFormularioEdit}
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
      </div>

      {/* Mostrar Valores Negativos, Legend y Voltear Gráfico */}
      <div className="row">
        <div className="col-md-3 mb-3">
          <label htmlFor="isShowNegativeValue" className="form-label">Mostrar Valores Negativos</label>
          <select
            id="isShowNegativeValue"
            name="isShowNegativeValue"
            className="form-select"
            value={formularioEditGraph.isShowNegativeValue ? 1 : 0}
            onChange={handleChangeFormularioEdit}
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <label htmlFor="isShowLegendGraph" className="form-label">Mostrar Legend</label>
          <select
            id="isShowLegendGraph"
            name="isShowLegendGraph"
            className="form-select"
            value={formularioEditGraph.isShowLegendGraph ? 1 : 0}
            onChange={handleChangeFormularioEdit}
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <label htmlFor="isReventGraph" className="form-label">Voltear Gráfico</label>
          <select
            id="isReventGraph"
            name="isReventGraph"
            className="form-select"
            value={formularioEditGraph.isReventGraph ? 1 : 0}
            onChange={handleChangeFormularioEdit}
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <label htmlFor="isThousandFormat" className="form-label">Formato Mil</label>
          <select
            id="isThousandFormat"
            name="isThousandFormat"
            className="form-select"
            value={formularioEditGraph.isThousandFormat ? 1 : 0}
            onChange={handleChangeFormularioEdit}
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>

        <div className="col-md-3 mb-3">
          <label htmlFor="isMiniGraph" className="form-label">Is Mini</label>
          <select
            id="isMiniGraph"
            name="isMiniGraph"
            className="form-select"
            value={formularioEditGraph.isMiniGraph ? 1 : 0}
            onChange={handleChangeFormularioEdit}
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
        </div>

        <div className="col-md-3 mb-3">
          <label htmlFor="isYAxisActive" className="form-label">Is Y Axis Active</label>
          <select
            id="isYAxisActive"
            name="isYAxisActive"
            className="form-select"
            value={formularioEditGraph.isYAxisActive ? 1 : 0}
            onChange={handleChangeFormularioEdit}
          >
            <option value={1}>Sí</option>
            <option value={0}>No</option>
          </select>
          </div>
          <div className="col-md-3 mb-3">
          <label htmlFor="yAxisMax" className="form-label">Y Axis Max</label>
          <input
            type="number"
            id="yAxisMax"
            name="yAxisMax"
            value={formularioEditGraph.yAxisMax}
            onChange={handleChangeFormularioEdit}
            className="form-control"
          />
          </div>
      </div>

      {/* Agregar Inputs y Listado de Valores */}
      {/* <div className="mb-3">
        <label htmlFor="nombreGrafico" className="form-label">Agregar Inputs</label>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            id="nombreGrafico"
            name="nombreGrafico"
            value={tagValue}
            onChange={(e) => settagValue(e.target.value)}
          />
          <button className="btn btn-secondary" type="button" onClick={addTagValue}>
            Agregar
          </button>
        </div>
      </div> */}

      <div className="mb-3">
        <label className="form-label">Listado Valores</label>
        <Select
                 className="react-select-container"
                 classNamePrefix="react-select"
                    isMulti
                    placeholder="Seleccionar..."
                    styles={customStyles}
                    closeMenuOnSelect={true}
                    options={selectOptions}
                    onChange={onChangeSelect}
                    value={formularioEditGraph.listadoValores}
                />
        {/* <div className="d-flex flex-wrap gap-2">

          {formularioEditGraph.listadoValores.map((item: any) => (
            <div key={item.value} className="badge bg-warning d-flex align-items-center">
              <span>{item.value}</span>
              <button
                type="button"
                className="btn-close btn-sm ms-2"
                aria-label="Close"
                onClick={() => removeTagValue(item.value)}
              ></button>
            </div>
          ))}
        </div> */}
      </div>

      {/* Botón de Actualizar */}
      <div className="d-grid gap-2 d-md-flex justify-content-md-end">
        <button
          type="submit"
          className="btn btn-primary"
          onClick={handleSubmitEdit}
        >
          Actualizar Gráfico
        </button>
      </div>
    </form>
  </div>
  <div className="card-footer"></div>
</div>
    </>
  );
};

export default CrearGraficoDinamic;
